import React, {useContext, useEffect, useState} from "react";
import './Inventory.css'
import axios from 'axios';
import './ClientPortal.css'
import {Elink, FetchEstimateInventoriesUrl, UpdateInventoriesUrl, FetchRoomsWithMoveSize} from "../CommonComponents/Routes";
import Loader from "../CommonComponents/Loader";
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import swal from 'sweetalert';

export default () => {//component is used to show the inventory modal content
    const [BodyState, setBodyState] = useState("MINI-LOADING")
    const [Show, Activate] = useState("LOADER")
    const [customRoomValue, setCustomRoomValue] = useState("")
    const [customRoomModal, setCustomRoomModal] = useState("none")
    const [CompanyInventories, setCompanyInventories] = useState({})
    const [EstRooms, SetestRooms] = useState({})
    const [SearchInventory, SetSearchInventory] = useState({})
    const [OverSizedItems, SetOverSizedItems] = useState({})
    const [OverSizedItemsRecord, SetOverSizedItemsRecord] = useState({})
    const [PercentageRooms, SetPercentageRooms] = useState({})
    const [PercentageInventories, SetPercentageInventories] = useState({})
    const [Floor, SetFloor] = useState([[]])
    const [SquareFootageAndMoveSize, setSquareFootageAndMoveSize] = useState({})
    const [MoveSize, SetMoveSize] = useState("")
    const [SquareFootage, SetSquareFootage] = useState(SquareFootageAndMoveSize.SquareFootage)
    const [Boxes, setBoxes] = useState(SquareFootageAndMoveSize.Boxes)
    const [Disabled, setDisabled] = useState(false)
    const [RoomCategories, setRoomCategories] = useState({})
    const [SelectedRoomtTypeID, setRoomtTypeID] = useState('')
    const [SelectedRoomtID, setRoomtID] = useState('')
    const [NewInventoryCount, increaseNewInventoryCount] = useState(0)
    const [NewRoomCount, increaseNewRoomCount] = useState(0)
    const [PercentNewRoomCount, setPercentNewRoomCount] = useState(0)
    const [, forceUpdate] = React.useState(0);
    const PageView = useContext(ViewMangementContext)
    const RecordsController = useContext(RecordsManagementContext)
    let Estimate = RecordsController.CP_PageDetails.EstimateDetails.JobDetails
    const Add_room_with_move_size =  RecordsController.CP_PageDetails.AddRoomWithMoveSize
    Estimate = Estimate.JobDetails == undefined ? Estimate : Estimate.JobDetails
    const IsCustomerEditEstAftrBook = RecordsController.IsJobOpen


    useEffect(async () => {//post request is send to "fetch_estimate_inventories" to fetch the inventory record of the estimate
        await axios({method: 'post', url: FetchEstimateInventoriesUrl, params: {estimate_key: Elink}})
            .then(async (response) => {
                let Message = response.data.Message
                if (Message && Message.Status === 'failed'){
                    window.location.reload();
                }
                else{
                    await SetestRooms(response.data.EstimateRooms)
                    await SetMoveSize(response.data.SquareFeetAndMoveSize.MoveSize)
                    await setRoomCategories(response.data.RoomCategories)
                    await SetFloor(response.data.CompanyFloors)
                    await setSquareFootageAndMoveSize(response.data.SquareFeetAndMoveSize)
                    await SetSearchInventory(response.data.CompanyInventories);
                    await SetOverSizedItems(response.data.PercentageInventories);
                    await SetOverSizedItemsRecord(response.data.PercentageInventories);
                    await SetPercentageRooms(response.data.PercentageRoomEstimate);
                    await SetPercentageInventories(response.data.PercentageInventoriesEstimate);
                    await setCompanyInventories({
                        List: response.data.CompanyInventories
                    })
                    await Activate('INVENTORY-LIST')
                    await setBodyState('Estimate Inventories')
                }
            })
    }, [])
    const ClearAll = async () => {// used to clear all the rooms with their inventories.
        if (Estimate.PriceChecklistInventoryType){
            if (Object.keys(PercentageRooms).length > 0){
                await swal({
                    title: "Are you sure?",
                    text: "Once deleted, you will not be able to recover this room or inventories!",
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                }).then(async (willDelete) => {
                    if (willDelete) {
                        SetPercentageRooms({})
                    }});
            }
            else{
                await swal({
                    text: "No room added!",
                    icon: "error"
                });
            }

        }
        else{
            if (Object.keys(EstRooms).length === 1 && EstRooms[""]["Name"] === "NO ROOM" && Object.keys(EstRooms[""]["Inventories"]).length === 0) {
                await swal({
                    text: "No inventories or room added!",
                    icon: "error"
                });
            } else {
                await swal({
                    title: "Are you sure?",
                    text: "Once deleted, you will not be able to recover this room or inventories!",
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                }).then(async (willDelete) => {
                    if (willDelete) {
                        await setDisabled(true)
                        let est_room = {}
                        est_room[''] = {
                            Id: '',
                            Name: "NO ROOM",
                            Inventories: {}
                        }
                        await SetestRooms(est_room)
                        await setRoomtID('')
                        await setDisabled(false)
                        await swal("Your inventories and room has been deleted!", {
                            icon: "success",
                        });
                    }
                });
            }
        }
    }


    const CustomRoom = async (value) => {//used to add custom room
        if (value) {
                await setDisabled(true)
                await setCustomRoomModal("none")
                let room_keys = Object.keys(RoomCategories)
                await setCustomRoomValue('')
                let RoomCount = NewRoomCount
                let roomId = "NewRoom" + RoomCount
                await setRoomtID(roomId)
                let est_room = EstRooms
                est_room[roomId] = {
                    Id: roomId,
                    Name: value.toUpperCase(),
                    RoomTypeId: room_keys[0],
                    Inventories: {}
                }
                await increaseNewRoomCount(RoomCount += 1)
                await SetestRooms(EstRooms)
                await setDisabled(false)

        } else {
            PageView.setAlertProperty({
                Message: 'Please enter a room name',
                Type: 'warning',
                Show: true,
                AutoHide: true
            })
        }

    }

    const AddNewRoom = async (value) => {
            if (value !== '' && value !== "CUSTOM ROOM") {
                if (Estimate.PriceChecklistInventoryType) {
                    let record = PercentageRooms
                    let count = PercentNewRoomCount
                    let roomCategory = RoomCategories[value]
                    record["NewRoom"+count] = {
                        Id: "NewRoom"+count,
                        Name: roomCategory.Name,
                        Capacity: 10,
                        RoomTypeId: value,
                        Notes: "",
                        FloorId: Floor[0][0],
                    }
                    await setPercentNewRoomCount(count += 1)
                    await SetPercentageRooms(record)
                    forceUpdate(n => !n)
                }
                else{
                    await setDisabled(true)
                    let RoomCount = NewRoomCount
                    let roomId = "NewRoom" + RoomCount
                    await setRoomtID(roomId)
                    let roomCategory = RoomCategories[value]
                    let est_room = EstRooms
                    est_room[roomId] = {
                        Id: roomId,
                        Name: roomCategory.Name,
                        RoomTypeId: value,
                        Inventories: {}
                    }
                    await increaseNewRoomCount(RoomCount += 1)
                    await SetestRooms(EstRooms)
                    await setDisabled(false)
                }
            } else if (value === "CUSTOM ROOM") {
                setCustomRoomModal("block")
            } else {
                PageView.setAlertProperty({
                    Message: 'please select any Room Category to Add Room.',
                    Type: 'warning',
                    Show: true,
                    AutoHide: true
                })
            }

    }

    const AddRoomsWithMoveSize = (type) => {
        SetMoveSize(type)
        if(Add_room_with_move_size){
            fetchRoomsWithMoveSize(type, NewRoomCount)
        }
    }

    const fetchRoomsWithMoveSize = async (move_size_for, room_count) => {
        await axios({
            method: 'post',
            url: FetchRoomsWithMoveSize,
            params: {move_size_for: move_size_for, room_count: room_count, estimate_key: Elink}
        })
            .then(async (response) => {
                if (response.data.status) {
                    Object.entries(EstRooms).map(([key, value]) => ( // delete already present rooms added with move size
                        value["added_by_move_size"] == true ? RemoveRooms(key) : ""
                    ))
                    var old_rooms = EstRooms
                    Object.assign(old_rooms, response.data.EstimateRooms);
                    await SetestRooms(old_rooms)
                    await increaseNewRoomCount(response.data.room_count)
                }
            })
    }

    const AddOverSizedItem = async (inventory_id,inventory_name) => {
        let record = PercentageInventories
        let id = 'NewInventory' + inventory_id
        if (inventory_id !== '') {
            if (record[inventory_id] !== undefined ){
                record[inventory_id].Qty += 1
                forceUpdate(n => !n)
            }
            else if (record[id] !== undefined ){
                record[id].Qty += 1
                forceUpdate(n => !n)
            }
            else if (record[id] === undefined ){
                record[id] = {
                    Id: id,
                    Name: inventory_name,
                    Qty: 1,
                    FloorId: Floor[0][0],
                    InventoryId: inventory_id,
                }
                forceUpdate(n => !n)
            }
        }
        SetPercentageInventories(record)
    }

    const AddNewInventory = async (inventory_id) => {//used to add new inventory
        if (inventory_id !== '') {
            let isAlreadyExist = false,
                InventoryId = 0,
                COMPANY_INVENTORY = CompanyInventories.List[inventory_id],
                COUNT = NewInventoryCount
            let est_room = EstRooms[SelectedRoomtID]
            if (est_room.Inventories != null) {
                let inventories = est_room.Inventories
                Object.entries(inventories).map(([id, Inventory]) => {
                    if (Inventory.RoomEstimateId === null) {
                        Inventory.RoomEstimateId = ""
                    }
                    if (Inventory.InventoryId === inventory_id && ((Inventory.RoomEstimateId).toString()) === SelectedRoomtID) {
                        isAlreadyExist = true
                        InventoryId = id
                    }
                })
                if (isAlreadyExist === true && InventoryId !== 0) {
                    inventories[InventoryId].Qty += 1
                } else if (isAlreadyExist === false && InventoryId === 0) {
                    let id = 'NewInventory' + COUNT
                    inventories[id] = {
                        Id: id,
                        Name: COMPANY_INVENTORY.Name,
                        Qty: 1,
                        FloorId: Floor[0][0],
                        InventoryId: COMPANY_INVENTORY.Id,
                        RoomEstimateId: SelectedRoomtID
                    }
                    increaseNewInventoryCount(COUNT += 1)
                }
                let est_rooms = EstRooms
                est_room.Inventories = inventories
                est_rooms[SelectedRoomtID] = est_room
                SetestRooms(est_rooms)
                forceUpdate(n => !n)
            } else {
                PageView.setAlertProperty({
                    Message: 'please select any one Inventory to Add new Inventory.',
                    Type: 'warning',
                    Show: true,
                    AutoHide: true
                })
            }
        }
    }

    const RemovePercentageRooms = async (room_id) => {
        let rooms = PercentageRooms
        await delete rooms[room_id]
        await SetPercentageRooms(rooms)
        forceUpdate(n => !n)
    }
    const RemoveOverSizedInventory = async (inventory_id) => {
        let inventory = PercentageInventories
        await delete inventory[inventory_id]
        await SetPercentageInventories(inventory)
        forceUpdate(n => !n)
    }


    const RemoveRooms = async (room_id) => {//used to remove existing rooms
        await setDisabled(true)
        let est_rooms = EstRooms
        if (room_id === null) {
            room_id = ""
        }
        delete est_rooms[room_id]
        await SetestRooms(est_rooms)
        await setRoomtID('')
        await setDisabled(false)
    }


    const ShowInventoriesWithRoom = (EstRoom, RoomInventories) => {//show inventories
        return (
            <>
                <div className="Inventory_heading">
                    <span className="show-right">{EstRoom.Name}</span>
                    <span className="show-left"> No. of Items : {Object.keys(RoomInventories).length}</span>
                </div>
                <table className="table show_table_inventories">
                    {Object.keys(RoomInventories).length > 0 ?
                        <thead>
                        <tr id={"show-inventory-lbl"}>
                            <th>Item</th>
                            <th>Floor</th>
                            <th>Quantity</th>
                        </tr>
                        </thead>
                        :
                        <></>
                    }
                    <tbody>
                    {Object.keys(RoomInventories).length > 0 ?
                        Object.entries(RoomInventories).map(([id, Inventory]) => {
                            return (<InventoryDetails key={id} Inventory={Inventory}/>)
                        })
                        :
                        <td>
                            {EstRoom.Name === "NO ROOM" ? <div className="text-center">
                                    <b>No items are added!</b></div> :
                                <div className="text-center"><b className="text-center">
                                    No items are added to this room!</b></div>}
                        </td>
                    }
                    </tbody>
                </table>
            </>
        )
    }
    const PercentageInventoriesRecord = (props) => {
        let Inventory = props.Inventory
        let KeyValue = props.KeyValue
        return (
            <>
            <tr className={"tbl-rw"}>
                <td className={"td-class td-class"}>
                    <label id={"lbl-id"} className={"item-lbl"}
                           style={{display: "none", marginBottom: "0"}}>ITEM</label>
                    {Inventory.Name}
                </td>

                <td className={"td-class"}>
                    <label className={"floor-lbl"} id={"lbl-id"}
                           style={{display: "none", marginBottom: "0"}}>FLOOR</label>
                    {IsCustomerEditEstAftrBook ?
                        <select className="custom-select shadow"
                                style={{width: "70%", margin: "2%"}}
                                onChange={(e) =>
                                    ManagePercentageFloor(e.target.value, KeyValue,"inventories")}
                                value={Inventory.FloorId}>
                            {Object.entries(Floor).map(([id, floor]) => {
                                return (
                                    <option key={id} value={floor[0]}>{floor[1]}</option>
                                )
                            })}
                        </select> : Inventory.Floor}
                </td>

                <td className={"td-class"}>
                    <label id={"lbl-id"} style={{display: "none", marginBottom: "0"}}>QTY</label>
                    <InventoryQty Inventory={Inventory} KeyValue={KeyValue}/>
                    {IsCustomerEditEstAftrBook ?
                        <span style={{margin: "2.5%"}}>
                                {Inventory.RoomEstimateId === null ? Inventory.RoomEstimateId = "" : <></>}
                            <button className="btn btn-danger btn-sm"
                                    onClick={() => RemoveOverSizedInventory(KeyValue)}
                            >
                                    <b>X</b>
                                </button>
                            </span>
                        : ''}
                </td>
            </tr>
    </>
    )
    }

    const PercentageRoomsAndInventories = (EstRoom) => {
        return (
                <div className="package-table-list ">
                    <div className="show-inventory-detail">
                        <div style={{maxWidth: "56%"}}>
                            <span>{EstRoom.Name.toUpperCase()}</span>

                        </div>
                        <div className={"row"}>
                            <div className={"col"}>
                            <span style={{color: "white"}}>FLOOR</span>
                            </div>
                            <div className={"col"}>
                            {IsCustomerEditEstAftrBook ?
                                <select className="custom-select shadow"
                                        style={{width: "140%", margin: "2%",height:"32px"}}
                                        onChange={(e) =>
                                            ManagePercentageFloor(e.target.value, EstRoom.Id,"rooms")}
                                        value={EstRoom.FloorId}>
                                    {Object.entries(Floor).map(([id, floor]) => {
                                        return (
                                            <option key={id} value={floor[0]}>{floor[1]}</option>
                                        )
                                    })}
                                </select> : EstRoom.Floor}
                            </div>
                        </div>
                        {IsCustomerEditEstAftrBook ?
                        <div>
                            <span className='remove-inventory' style={{cursor: "pointer"}}
                                      onClick={() => RemovePercentageRooms(EstRoom.Id)}><b>x</b></span>

                        </div>: ""}
                    </div>
                    <div className="row" style={{paddingTop:"2%"}}>
                        <div className={"col"} style={{color: "black",fontSize: "14px"}}>How full is the room : </div>
                        <div className="col">
                            <input type="range" name="rangeInput" min="10" max="200" value={EstRoom.Capacity}
                                  style={{width:"75%",marginRight: "5px"}} onChange= {(e) =>
                                updateCapacityValue(e.target.value,EstRoom.Id)} disabled={IsCustomerEditEstAftrBook ? false : true}/>
                                <span id={"textInput"+ EstRoom.Id}>{EstRoom.Capacity}</span>
                        </div>
                        <div className="col">
                            <textarea  value={EstRoom.Notes} id={"RoomNotes"+EstRoom.Id} className="notes-textarea"
                                 placeholder={"Any special info about the room"} style={{borderRadius: "4px",
                                border: "1px solid #aaaaaa",height:"33px"}}
                                   onChange= {(e) => updateNotesValue(e.target.value,EstRoom.Id)} rows="3"
                                       disabled={IsCustomerEditEstAftrBook ? false : true}></textarea>
                        </div>
                    </div>
                </div>
        )

    }
    function updateNotesValue(val,Room_id) {
        let id ='RoomNotes' + Room_id
        let rooms_record = PercentageRooms
        document.getElementById(id).value = val
        rooms_record[Room_id].Notes = val
        forceUpdate(n => !n)
    }
    function updateCapacityValue(val,Room_id) {
        let id ='textInput' + Room_id
        let rooms_record = PercentageRooms
        document.getElementById(id).innerText = val
        rooms_record[Room_id].Capacity = val
        forceUpdate(n => !n)
    }

    const EstRoomWithInventories = (props) => {//show rooms with inventories
        let [EstRoom, setEstRoom] = useState(props.EstRoom)
        let [RoomInventories, setRoomInventories] = useState(props.EstRoom.Inventories)
        useEffect(() => {
            setEstRoom(props.EstRoom)
            setRoomInventories(EstRoom.Inventories || {})
        }, [])
        return (
            IsCustomerEditEstAftrBook ?
                <div className="package-table-list ">
                    <div className="show-inventory-detail" onClick={() => setRoomtID(EstRoom.Id)}
                         style={{boxShadow: EstRoom.Id === SelectedRoomtID ? "0px 0px 13px 0px #26a9e0" : ""}}>
                        <div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg" className="bi bi-check-lg" viewBox="0 0 16 16"
                                display={EstRoom.Id === SelectedRoomtID ? "block" : "none"}>
                                <path
                                    d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
                            </svg>
                        </div>
                        <div>
                            <span>{EstRoom.Name}</span>
                        </div>
                        <div>
                            <span>No. of Items : {Object.keys(RoomInventories).length}</span>
                        </div>
                        <div>
                            {EstRoom.Name === "NO ROOM" ?
                                <b className='text-dark'>.</b>
                                :
                                <span className='remove-inventory' style={{cursor: "pointer"}}
                                      onClick={() => RemoveRooms(EstRoom.Id)}><b>x</b></span>
                            }
                        </div>
                    </div>
                    <table className="show-inventory-table">
                        {Object.keys(RoomInventories).length > 0 ?
                            <thead>
                            <tr>
                                <th>Item</th>
                                <th>Floor</th>
                                <th>Quantity</th>
                            </tr>
                            </thead>
                            :
                            <></>
                        }
                        <tbody>
                        {Object.keys(RoomInventories).length > 0 ?
                            Object.entries(RoomInventories).map(([id, Inventory]) => {
                                return (<InventoryDetails key={id} Inventory={Inventory}/>)
                            })
                            :
                            <td>
                                {EstRoom.Name === "NO ROOM" ? <b>No items are added!</b> :
                                    <b>No items are added to this room!</b>}
                            </td>
                        }
                        </tbody>
                    </table>
                </div>
                :
                EstRoom.Name === "NO ROOM" && Object.keys(EstRoom.Inventories).length === 0 ?
                    <></>
                    :
                    ShowInventoriesWithRoom(EstRoom, RoomInventories)


        )
    }
    const ManageFloor = (floor_id, inventory_id, room_estimate_id) => {//used to save floors for inventories
        let est_rooms = EstRooms
        if (room_estimate_id === null) {
            room_estimate_id = ""
        }
        let est_room = est_rooms[room_estimate_id]
        let inventories = est_room.Inventories
        inventories[inventory_id].FloorId = floor_id
        est_room.Inventories = inventories
        est_rooms[room_estimate_id] = est_room
        SetestRooms(est_rooms)
        forceUpdate(n => !n)
    }
    const ManagePercentageFloor = (floor_id,inventory_id,For) => {
        let inventories = For === "rooms" ? PercentageRooms : PercentageInventories
        inventories[inventory_id].FloorId = floor_id
        For === "rooms" ? SetPercentageRooms(inventories) : SetPercentageInventories(inventories)
        forceUpdate(n => !n)
    }

    const InventoryDetails = (props) => {//shows the inventory details (total number of items ,floors and inventory name).
        let Inventory = props.Inventory || {}
        return (
            <>
                <tr className={"tbl-rw"}>
                    <td className={"td-class td-class"}>
                        <label id={"lbl-id"} className={"item-lbl"}
                               style={{display: "none", marginBottom: "0"}}>ITEM</label>
                        {Inventory.Name}
                    </td>

                    <td className={"td-class"}>
                        <label className={"floor-lbl"} id={"lbl-id"}
                               style={{display: "none", marginBottom: "0"}}>FLOOR</label>
                        {IsCustomerEditEstAftrBook ?
                            <select className="custom-select shadow"
                                    style={{width: "70%", margin: "2%"}}
                                    onChange={(e) =>
                                        ManageFloor(e.target.value, Inventory.Id, Inventory.RoomEstimateId)}
                                    value={Inventory.FloorId}>
                                {Object.entries(Floor).map(([id, floor]) => {
                                    return (
                                        <option key={id} value={floor[0]}>{floor[1]}</option>
                                    )
                                })}
                            </select> : Inventory.Floor}
                    </td>

                    <td className={"td-class"}>
                        <label id={"lbl-id"} style={{display: "none", marginBottom: "0"}}>QTY</label>
                        <InventoryQty Inventory={Inventory}/>
                        {IsCustomerEditEstAftrBook ?
                            <span style={{margin: "2.5%"}}>
                                {Inventory.RoomEstimateId === null ? Inventory.RoomEstimateId = "" : <></>}
                                <button className="btn btn-danger btn-sm"
                                        onClick={() => RemoveInventory(Inventory.Id, Inventory.RoomEstimateId)}
                                >
                                    <b>X</b>
                                </button>
                            </span>
                            : ''}
                    </td>
                </tr>
            </>
        )
    }

    const RemoveInventory = (id, room_estimate_id) => {//remove inventories
        let est_rooms = EstRooms
        if (room_estimate_id === null) {
            room_estimate_id = ""
        }

        let est_room = est_rooms[room_estimate_id]
        let inventories = est_room.Inventories
        delete inventories[id]
        est_room.Inventories = inventories
        est_rooms[room_estimate_id] = est_room
        SetestRooms(est_rooms)
        forceUpdate(n => !n)
    }

    const ChangeQtyFor = (value, id, room_estimate_id) => {//change quantity manually.
        if (Estimate.PriceChecklistInventoryType){
            let record = PercentageInventories
            if (!isNaN(value)) {
                record[id].Qty = value
            }
            if (record[id].Qty === 0 || isNaN(value)) {
                delete record[id]
            }
            SetPercentageInventories(record)
            forceUpdate(n => !n)
        }
        else{
            let est_rooms = EstRooms
            if (room_estimate_id === null) {
                room_estimate_id = ""
            }
            let est_room = est_rooms[room_estimate_id]
            let inventory = est_room.Inventories[id]
            if (!isNaN(value)) {
                inventory.Qty = value
            }
            if (inventory.Qty === 0 || isNaN(value)) {
                delete est_room.Inventories[id]
            } else {
                est_room.Inventories[id] = inventory
            }
            est_rooms[room_estimate_id] = est_room
            SetestRooms(est_rooms)
            forceUpdate(n => !n)
        }

    }

    const InventoryQty = (props) => {//component used to check if the increase or decrease btns will shown or not according to the condition
        let Inventory = props.Inventory
        let KeyValue = props.KeyValue
        if (IsCustomerEditEstAftrBook) {
            return (
                <>
                    <ChngQtyBtn Id={Estimate.PriceChecklistInventoryType ? KeyValue : Inventory.Id} For={'-'} RoomEstimateId={Estimate.PriceChecklistInventoryType ? "" :
                        Inventory.RoomEstimateId}/>
                    <input type="text" pattern="[0-9]*" className='packing-nm' defaultValue={Inventory.Qty}
                           onKeyUp={(e) => e.target.validity.valid ? "" : ChangeQtyFor(Inventory.Qty,
                               KeyValue, Estimate.PriceChecklistInventoryType ? "" : Inventory.RoomEstimateId)}
                           onBlur={(e) => ChangeQtyFor(parseInt(e.target.value),
                               KeyValue,Estimate.PriceChecklistInventoryType ? "" : Inventory.RoomEstimateId)}></input>
                    <ChngQtyBtn Id={Estimate.PriceChecklistInventoryType ? KeyValue : Inventory.Id} For={'+'} RoomEstimateId={Estimate.PriceChecklistInventoryType ? "" :
                        Inventory.RoomEstimateId}/>
                </>
            )
        } else {
            return (
                Inventory.Qty
            )

        }

    }

    const ChngQtyBtn = (props) => {//increase or decrease btns
        if (IsCustomerEditEstAftrBook) {
            return (
                <button
                    className={props.For === '+' ? ' btn btn-primary btn-sm increase-decrease-btn plus-bt' : ' btn btn-primary btn-sm increase-decrease-btn minus-bt'}
                    onClick={() => ChangeQty(props.Id, props.For === '+' ? 'Increment' : 'Decrement', props.RoomEstimateId)}>
                    {props.For}
                </button>
            )
        } else {
            return ''
        }
    }

    const ChangeQty = (id, type, room_estimate_id) => { // increase or decrease the quantity
        if (Estimate.PriceChecklistInventoryType){
            let record = PercentageInventories
            type === 'Decrement' ? record[id].Qty -= 1 : record[id].Qty += 1
            if (record[id].Qty === 0) {
                delete record[id]
            }
            SetPercentageInventories(record)
            forceUpdate(n => !n)
        }
        else{
            let est_rooms = EstRooms
            if (room_estimate_id === null) {
                room_estimate_id = ""
            }
            let est_room = est_rooms[room_estimate_id]
            let inventory = est_room.Inventories[id]
            type === 'Decrement' ? inventory.Qty -= 1 : inventory.Qty += 1
            if (inventory.Qty === 0) {
                delete est_room.Inventories[id]
            } else {
                est_room.Inventories[id] = inventory
            }
            est_rooms[room_estimate_id] = est_room
            SetestRooms(est_rooms)
            forceUpdate(n => !n)
        }

    }

    const updateInventoryQty = async (hash, showMessage) => {//
        let cookie = document.cookie.split('employee_id=')[1]//check if current employee is admin or not
        await axios({//post request is send to the "update_inventories" function for updating the inventories of the estimate.
            method: 'post',
            url: UpdateInventoriesUrl,
            data: {
                estimate_key: Elink,
                employee_key: cookie,
                estimate_rooms_hash: Estimate.PriceChecklistInventoryType ? "" : hash,
                MoveSize: MoveSize === "Select" ? "" : MoveSize,
                SquareFootage: SquareFootage,
                Boxes: Boxes === undefined ? SquareFootageAndMoveSize.Boxes : Boxes,
                percentage_rooms: PercentageRooms,
                percentage_inventories: PercentageInventories
            }
        })
            .then((response) => {// update the page content
                {
                    PageView.setModalContent({Title: '', Body: '', Class: ''})
                    let Message = response.data.Message
                    if(Message && Message.Text === "Expired Link"){
                        window.location.reload();
                    }
                    else if (Message.Status == undefined) {
                        RecordsController.SetCP_PageDetails({
                            ...RecordsController.CP_PageDetails,
                            EstimateDetails: {
                                ...RecordsController.CP_PageDetails.EstimateDetails,
                                JobDetails: response.data.JobDetails
                            }

                        })
                    }
                    if (showMessage === true) {
                        PageView.setAlertProperty({
                            Message: Message.Text,
                            Type: Message.Type,
                            Show: true,
                            AutoHide: true
                        })
                    }

                }
            })
    }

    const TotalInventories = () => {//calculate the total number of inventory
        let sum = 0
        {
            Object.entries(EstRooms).map(([id, estRoom]) => {
                {
                    Object.entries(estRoom.Inventories).map(([id, inventory]) => {
                        sum += parseInt(inventory.Qty)
                    })
                }
            })
        }
        return sum
    }

    const searchText = (e) => {//used for searching the inventories
        let text = e.toLowerCase();
        let searchData = {}
        Object.entries(Estimate.PriceChecklistInventoryType ? OverSizedItems : CompanyInventories.List).map(([id, inventories]) => {
            let inventory = Estimate.PriceChecklistInventoryType ? inventories.name.toLowerCase() :  inventories.Name.toLowerCase();
            if (inventory.match(text)) {
                searchData[ Estimate.PriceChecklistInventoryType ? inventories.id : inventories.Id] = inventories
            }
        })
        Estimate.PriceChecklistInventoryType ? text === "" ? SetOverSizedItems(OverSizedItemsRecord) : SetOverSizedItems(searchData) :
            SetSearchInventory(searchData);
    };

    const updateBtn = IsCustomerEditEstAftrBook ?
        <button className="btn btn-primary" data-dismiss="modal"
                onClick={() => updateInventoryQty(EstRooms, true)}>
            Update
        </button> : ''

    if (BodyState === 'MINI-LOADING') {
        return (
            <Loader For={'AJAX'} UniqueId={'4'}/>
        );
    } else {

        return (
            <div style={Disabled ? {
                pointerEvents: "none", opacity: "0.3"
            } : {}}>
                {/* this loader is shown when we add new inventories or delete any room  */}
                {Disabled ?
                    <div id="page_loading">
                        <img id="loading-image" src={process.env.PUBLIC_URL + "Images/loader15.gif"} alt="Loading..."/>
                    </div>
                    : <></>
                }


                {IsCustomerEditEstAftrBook ?
                    <div className="package-table-list manage-inventory-wrap">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="manage-inventory-left-data">

                                    <div className="data-inventories-wrap" style={{boxShadow: "none"}}>
                                        {Show === 'INVENTORY-LIST' ?
                                            <div className='bg-light card shadow-lg w-100'>
                                                <div className='card-header' style={{padding: " 0.15rem 1.25rem"}}>
                                                    <b id="select_inventories">{Estimate.PriceChecklistInventoryType ?
                                                        "OVER SIZED ITEMS" : "SELECT INVENTORIES"}</b>
                                                    <input type="text" className={"form-control input_field_2"}
                                                           style={{float: "right", width: "50%", height: "1.8rem"}}
                                                           onKeyUp={(e) => searchText(e.target.value)}
                                                           placeholder={"Search..."}/>
                                                </div>

                                                <div className='card-body'>
                                                    {Show === 'INVENTORY-LIST' ?
                                                        <div className='fixed-height-for-inventories'>
                                                            {Object.entries(Estimate.PriceChecklistInventoryType ? OverSizedItems :
                                                                SearchInventory ).sort((a, b) =>
                                                                a[1][Estimate.PriceChecklistInventoryType ? "name" : "Name"].localeCompare(b[1][Estimate.PriceChecklistInventoryType ? "name" :
                                                                "Name"])).map(([id, Inventory]) => {
                                                                return (
                                                                    <div
                                                                        className='btn btn-sm btn-dark m-2 fixed-btn-for-inventories'
                                                                        id={'animation' + Estimate.PriceChecklistInventoryType ? Inventory.id :
                                                                            Inventory.Id}
                                                                        key={id}
                                                                        title={ Estimate.PriceChecklistInventoryType ? Inventory.name : Inventory.Name}
                                                                        onClick={() => Estimate.PriceChecklistInventoryType ? AddOverSizedItem(Inventory.id,Inventory.name) : AddNewInventory( Inventory.Id)}>
                                                                        <b>{Estimate.PriceChecklistInventoryType ? Inventory.name : Inventory.Name}</b>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div> : ""}
                                                </div>
                                            </div>
                                            :
                                            <></>
                                        }
                                    </div>

                                    <div className="room-inventory-details  desktop-vw"
                                         style={{marginTop: "1.5rem"}}>

                                        <h5>Rooms and Inventory Details</h5>
                                        <div className="inventory-rooms-data">
                                            {Estimate.PriceChecklistInventoryType ?  "" :
                                              <>
                                            <div>
                                                <label>
                                                    <div style={{float: "left"}}><span>Total Rooms: </span></div>
                                                </label>
                                                <div
                                                    style={{float: "right"}}>{Object.keys(EstRooms).length - 1}</div>
                                            </div>
                                            <br/></>}
                                            {Estimate.PriceChecklistInventoryType ?  "" :
                                             <>
                                            <div>
                                                <label>
                                                    <div style={{float: "left"}}><span>Total Inventories:</span>
                                                    </div>
                                                </label>
                                                <div style={{float: "right"}}>{TotalInventories()}</div>
                                            </div>
                                            <br/>
                                             </>}
                                            <div>
                                                <label>
                                                    <div style={{float: "left"}}><span>Total Square Footage:</span>
                                                    </div>
                                                </label>
                                                <div style={{float: "right"}}>
                                                    <input type="text" className="form-control input_field_2"
                                                           style={{width: "8rem"}}
                                                           value={SquareFootage}
                                                           onChange={(e) =>
                                                               SetSquareFootage(e.target.value.replace(/\D/g, ""))}
                                                           placeholder={SquareFootageAndMoveSize.SquareFootage}/>
                                                </div>
                                            </div>
                                            <br/><br/>

                                            {Estimate.hideBoxes ?
                                                <>
                                                    <div><label>
                                                        <div style={{float: "left"}}><span
                                                            style={{marginTop: "-15%"}}>Total Estimated Boxes/Totes:</span>
                                                        </div>
                                                    </label>
                                                        <div style={{float: "right"}}>
                                                            <input type="text" className="form-control input_field_2"
                                                                   style={{width: "8rem"}} value={Boxes}
                                                                   onChange={(e) =>
                                                                       setBoxes(e.target.value.replace(/\D/g, ""))}
                                                                   placeholder={SquareFootageAndMoveSize.Boxes}/>
                                                        </div>
                                                    </div>
                                                    <br/><br/></>
                                                :
                                                <></>
                                            }
                                            {Estimate.PriceChecklistInventoryType ?  "" :
                                            <div style={{paddingBottom: "15%"}}>
                                                <div style={{float: "left"}}><label>Move Size: </label></div>
                                                <div style={{float: "right"}}><select
                                                    className="custom-select shadow"
                                                    id="selct-box"
                                                    value={MoveSize}
                                                    onChange={(e) =>
                                                        AddRoomsWithMoveSize(e.target.value)}>
                                                    <option value="Select">select any one</option>
                                                    {Object.entries(SquareFootageAndMoveSize.MOVE_SIZE).map
                                                    (([id, move_size]) => {
                                                        return (
                                                            <option key={id} value={move_size}>{move_size}</option>
                                                        )
                                                    })}
                                                </select></div>

                                            </div>}
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="manage-inventory-right-data">
                                    <div className="room-type-detail">
                                        <div className="select-rooms-box">
                            <span>
                               <select className="custom-select shadow"
                                       id="selct-box"
                                       onChange={(e) => AddNewRoom(e.target.value)}
                                       value={SelectedRoomtTypeID}>
                                        <option disabled value="">Add new room</option>
                                   {Estimate.PriceChecklistInventoryType ? "" : <option value="CUSTOM ROOM">CUSTOM ROOM</option>}
                                   {Object.entries(RoomCategories).sort((a, b) =>
                                       a[1]["Name"].localeCompare(b[1]["Name"])).map(([id, RoomType]) => {
                                       return (
                                           <option key={id} value={RoomType.Id}>{RoomType.Name}</option>
                                       )
                                   })}
                                    </select>
                            </span>
                                            <span><button className={"add-packing-material btn-danger"}
                                                          style={{backgroundColor: "#cd2222"}}
                                                          onClick={() => ClearAll()}
                                                          title="It will remove all the inventories added.">Clear All</button></span>
                                        </div>
                                        <div id="customRoom" className="modal custom-room"
                                             style={{display: customRoomModal}}>
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h6 style={{color: "#4ab7e5"}}>Custom Room</h6>
                                                    <button type="button" className="close"
                                                            onClick={() => setCustomRoomModal("none", setCustomRoomValue(''))}
                                                            style={{color: "red"}}>×
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <div>
                                                        <div style={{float: "left"}}>
                                                            <span><input type="text" className="modal-text form-control"
                                                                         style={{width: "160px !important"}}
                                                                         value={customRoomValue}
                                                                         onChange={(e) =>
                                                                             setCustomRoomValue(e.target.value)}/></span>
                                                        </div>
                                                        <div style={{float: "left", margin: "25px 48px"}}>
                                                            <span><button className="add-packing-material btn-success"
                                                                          style={{fontSize: "80%"}}
                                                                          onClick={() => CustomRoom(customRoomValue)}>
                                                                Add Room</button></span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="modal-footer">
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="inventory-table-height">
                                        { Estimate.PriceChecklistInventoryType ?
                                            <>
                                            {Object.entries(PercentageRooms).reverse().map(([id, EstRoom]) => {
                                                return (PercentageRoomsAndInventories(EstRoom))
                                            })}
                                                <div className="show-inventory-detail">
                                                    <div>
                                                        <span>OVER SIZED ITEMS</span>
                                                    </div>
                                                    <div>
                                                        <b className='text-dark'>.</b>
                                                    </div>
                                                </div>
                                                    {IsCustomerEditEstAftrBook ?
                                                    <table className="show-inventory-table">
                                                        {Object.keys(PercentageInventories).length > 0 ?
                                                            <thead>
                                                            <tr>
                                                                <th>Item</th>
                                                                <th>Floor</th>
                                                                <th>Quantity</th>
                                                            </tr>
                                                            </thead>
                                                            :
                                                            <></>
                                                        }
                                                        <tbody>
                                                        {Object.keys(PercentageInventories).length > 0 ?
                                                            Object.entries(PercentageInventories).map(([id, Inventory]) => {
                                                                    return (<PercentageInventoriesRecord key={id} Inventory={Inventory}
                                                                            KeyValue={Object.keys(PercentageInventories).find(key =>
                                                                                PercentageInventories[key] === Inventory)}/> )
                                                                })
                                                            :
                                                            <td>
                                                                <b>No inventory items marked as oversized. </b>
                                                            </td>
                                                        }
                                                        </tbody>
                                                    </table> : <></> }

                                            </> :
                                        Object.entries(EstRooms).reverse().map(([id, EstRoom]) => {
                                            return (<EstRoomWithInventories key={id} EstRoom={EstRoom}/>)
                                        })}
                                    </div>

                                    <div className="room-inventory-details mt-5 mobile-vw">
                                        <>
                                            <h5>Rooms and Inventory Details</h5>
                                            <div className="inventory-rooms-data">
                                                {Estimate.PriceChecklistInventoryType ?  "" :
                                                  <>
                                                <div style={{paddingBottom: "20px"}}>
                                                    <label>
                                                        <div style={{float: "left"}}><span>Total Rooms: </span>
                                                        </div>
                                                    </label>
                                                    <div
                                                        style={{float: "right"}}>{Object.keys(EstRooms).length - 1}</div>
                                                </div>
                                                <br/> </>}
                                                {Estimate.PriceChecklistInventoryType ?  "" :
                                                <>
                                                <div style={{paddingBottom: "20px"}}>
                                                    <label>
                                                        <div style={{float: "left"}}><span>Total Inventories:</span>
                                                        </div>
                                                    </label>
                                                    <div style={{float: "right"}}>{TotalInventories()}</div>
                                                </div>
                                                <br/> </> }
                                                <div style={{paddingBottom: "20px"}}>
                                                    <label>
                                                        <div style={{float: "left"}}>
                                                            <span>Total Square Footage:</span></div>
                                                    </label>
                                                    <div style={{float: "right"}}><input type="text"
                                                       className="form-control input_field_2"
                                                       style={{width: "8rem"}}
                                                        value={SquareFootage}
                                                        onChange={(e) =>
                                                            SetSquareFootage(e.target.value.replace(/\D/g, ""))}
                                                        placeholder={SquareFootageAndMoveSize.SquareFootage}/>
                                                    </div>
                                                </div>
                                                <br/><br/>

                                                {Estimate.hideBoxes ?
                                                    <>
                                                        <div><label>
                                                            <div style={{float: "left"}}><span
                                                                style={{marginTop: "-15%"}}>Total Estimated Boxes/Totes:</span>
                                                            </div>
                                                        </label>
                                                            <div style={{float: "right"}}>
                                                                <input type="text" className="form-control input_field_2"
                                                                  style={{width: "8rem"}}
                                                                   value={Boxes}
                                                                   onChange={(e) =>
                                                                       setBoxes(e.target.value.replace(/\D/g, ""))}
                                                                    placeholder={SquareFootageAndMoveSize.Boxes}/>
                                                            </div>
                                                        </div>
                                                        <br/><br/></>
                                                    :
                                                    <></>
                                                }
                                                <br/>
                                                {Estimate.PriceChecklistInventoryType ?  "" :
                                                <div style={{paddingBottom: "15%"}}>
                                                    <div style={{float: "left"}}><label>Move Size: </label></div>
                                                    <div style={{float: "right"}}><select
                                                        className="custom-select shadow"
                                                        id="selct-box"
                                                        value={MoveSize}
                                                        onChange={(e) =>
                                                            SetMoveSize(e.target.value)}>
                                                        <option value="Select">select any one</option>
                                                        {Object.entries(SquareFootageAndMoveSize.MOVE_SIZE).map
                                                        (([id, move_size]) => {
                                                            return (
                                                                <option key={id}
                                                                        value={move_size}>{move_size}</option>
                                                            )
                                                        })}
                                                    </select></div>

                                                </div> }
                                            </div>
                                        </>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    :
                    Estimate.PriceChecklistInventoryType ?
                        <div className="package-table-list manage-inventory-wrap">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="manage-inventory-left-data">

                                        <div className="room-inventory-details  desktop-vw"
                                             style={{marginTop: "1.5rem"}}>

                                            <h5>Rooms and Inventory Details</h5>
                                            <div className="inventory-rooms-data">
                                                <div>
                                                    <label>
                                                        <div style={{float: "left"}}><span>Total Square Footage:</span>
                                                        </div>
                                                    </label>
                                                    <div style={{float: "right"}}>
                                                        <input type="text" className="form-control input_field_2"
                                                               style={{width: "8rem"}}
                                                               value={SquareFootage}
                                                               onChange={(e) =>
                                                                   SetSquareFootage(e.target.value.replace(/\D/g, ""))}
                                                               placeholder={SquareFootageAndMoveSize.SquareFootage} disabled/>
                                                    </div>
                                                </div>
                                                <br/><br/>

                                                {Estimate.hideBoxes ?
                                                    <>
                                                        <div><label>
                                                            <div style={{float: "left"}}><span
                                                                style={{marginTop: "-15%"}}>Total Estimated Boxes/Totes:</span>
                                                            </div>
                                                        </label>
                                                            <div style={{float: "right"}}>
                                                                <input type="text" className="form-control input_field_2"
                                                                       style={{width: "8rem"}} value={Boxes}
                                                                       onChange={(e) =>
                                                                           setBoxes(e.target.value.replace(/\D/g, ""))}
                                                                       placeholder={SquareFootageAndMoveSize.Boxes} disabled/>
                                                            </div>
                                                        </div>
                                                        <br/><br/></>
                                                    :
                                                    <></>
                                                }
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="room-inventory-details mt-5 mobile-vw">
                                    <>
                                        <h5>Rooms and Inventory Details</h5>
                                        <div className="inventory-rooms-data">
                                            <div style={{paddingBottom: "20px"}}>
                                                <label>
                                                    <div style={{float: "left"}}>
                                                        <span>Total Square Footage:</span></div>
                                                </label>
                                                <div style={{float: "right"}}><input type="text"
                                                                                     className="form-control input_field_2"
                                                                                     style={{width: "8rem"}}
                                                                                     value={SquareFootage}
                                                                                     onChange={(e) =>
                                                                                         SetSquareFootage(e.target.value.replace(/\D/g, ""))}
                                                                                     placeholder={SquareFootageAndMoveSize.SquareFootage}/>
                                                </div>
                                            </div>
                                            <br/><br/>

                                            {Estimate.hideBoxes ?
                                                <>
                                                    <div><label>
                                                        <div style={{float: "left"}}><span
                                                            style={{marginTop: "-15%"}}>Total Estimated Boxes/Totes:</span>
                                                        </div>
                                                    </label>
                                                        <div style={{float: "right"}}>
                                                            <input type="text" className="form-control input_field_2"
                                                                   style={{width: "8rem"}}
                                                                   value={Boxes}
                                                                   onChange={(e) =>
                                                                       setBoxes(e.target.value.replace(/\D/g, ""))}
                                                                   placeholder={SquareFootageAndMoveSize.Boxes}/>
                                                        </div>
                                                    </div>
                                                    <br/><br/></>
                                                :
                                                <></>
                                            }
                                        </div>
                                    </>
                                </div>

                                <div className="col-md-6">
                                    <div className="manage-inventory-right-data">
                                        <div className="inventory-table-height">
                                                    {Object.entries(PercentageRooms).reverse().map(([id, EstRoom]) => {
                                                        return (PercentageRoomsAndInventories(EstRoom))
                                                    })}
                                                    <div className="show-inventory-detail">
                                                        <div>
                                                            <span>OVER SIZED ITEMS</span>
                                                        </div>
                                                        <div>
                                                            <b className='text-dark'>.</b>
                                                        </div>
                                                    </div>
                                                        <table className="show-inventory-table">
                                                            {Object.keys(PercentageInventories).length > 0 ?
                                                                <thead>
                                                                <tr>
                                                                    <th>Item</th>
                                                                    <th>Floor</th>
                                                                    <th>Quantity</th>
                                                                </tr>
                                                                </thead>
                                                                :
                                                                <></>
                                                            }
                                                            <tbody>
                                                            {Object.keys(PercentageInventories).length > 0 ?
                                                                Object.entries(PercentageInventories).map(([id, Inventory]) => {
                                                                    return (<PercentageInventoriesRecord key={id} Inventory={Inventory}/>)
                                                                })
                                                                :
                                                                <td>
                                                                    <b>No inventory items marked as oversized. </b>
                                                                </td>
                                                            }
                                                            </tbody>
                                                        </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :

                    <div className="table-responsive table-borderless">
                        {Object.entries(EstRooms).map(([id, EstRoom]) => {
                            return (
                                Object.keys(EstRooms).length === 1 && EstRoom.Name === "NO ROOM" && Object.keys(EstRoom.Inventories).length === 0 ?
                                    <div className={'text-center'}><b>No Inventory Added . </b></div> :
                                    <EstRoomWithInventories key={id} EstRoom={EstRoom}/>)

                        })}
                    </div>

                }
                <div className='pack-mat-body update-bn text-center border-top'>
                    {updateBtn}
                </div>

            </div>
        )
    }

}

